/* eslint-disable @tencent/i18next/no-literal-string */
// [性能分析]log
import { generate } from 'shortid';
import { PERFORMANCE_VERSION } from '@src/slide/infrastructure/module/dependent/performance/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { BEGIN_RUN_TIME } from '@src/slide/infrastructure/module/dependent/performance/begin-time';

export const PERFORMANCE_ID = BEGIN_RUN_TIME + generate();

/**
 * TDW 上报
 * @param action
 * @param ver6
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function reportPerformance(action: string, ver6): void {
    tdw({
        opername: 'ppt_performance',
        module: 'start',
        action,
        ver5: 0,
        ver6: JSON.stringify(ver6),
    });
}

/**
 * 工具方法 返回相对网页开始刷新的时间戳
 * @returns {number}
 */
export function dateTimeFromNavigationStart(): number {
    return new Date().getTime() - window.performance.timing.navigationStart;
}
